import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'gl-contest-popup',
    templateUrl: './contest-popup.component.html',
    styleUrls: ['./contest-popup.component.scss'],
    standalone: false
})
export class ContestPopupComponent {
  constructor(private modalRef: ModalOverlayRef, public translate: TranslateService) {
    this.modalRef.backgroundClicked();
  }

  public openContestForm(): void {
    const landingPageUrl: string = this.translate.currentLang === 'pl' ? 'https://forms.gle/8YHz6iRvwexRAS2M8' : 'https://forms.gle/bDvzCHkbt1hG75pT9';
    window.open(landingPageUrl, '_blank');
  }

  public close() {
    this.modalRef.close();
  }
}
